import { DateTime } from "luxon";

import request from "../common/request.js";

// promise will only execute once per page load
let promise;

class Victim {
  constructor(obj) {
    Object.entries({
      id: "id",
      firstName: "first_name",
      lastName: "last_name",
      age: "age",
      gender: "gender",
      race: "race",
      cause: "cause",
      deathLocation: "death_loc",
      district: "district",
      streetAddress: "street_address",
      zipcode: "zip_code",
      latitude: "latitude",
      longitude: "longitude",
      dateFound: "date_found",
      timeFound: "time_found",
      notes: "notes"
    }).forEach(([attr, jsonKey]) => {
      this[attr] = obj[jsonKey];
    });
  }

  static async loadData() {
    promise =
      promise ||
      (async () => {
        let url = document.getElementById("victims-url").href;
        // Use data from the live site if the url has ?debug=live
        if (window.location.search.match(/debug=live/)) {
          url =
            "https://homicides.news.baltimoresun.com/baltimore-homicides-victims.json";
        }
        window.victims = Victim.unpack(await request(url));
        return window.victims;
      })();
    return await promise;
  }

  static unpack(json) {
    let results = [];
    for (let i = 0; i < json.data.length; i += json.headers.length) {
      let obj = {};
      json.headers.forEach((key, j) => {
        obj[key] = json.data[i + j];
      });
      results.push(new Victim(obj));
    }
    return results;
  }

  get fullName() {
    let name = this.firstName + " " + this.lastName;
    if (name === " ") {
      name = "Unreleased";
    }
    return name;
  }

  get url() {
    return `/victim/${this.id}/`;
  }

  get causeVerbose() {
    return {
      shooting: "Shooting",
      stabbing: "Stabbing",
      bluntforce: "Blunt Force",
      asphyxiation: "Asphyxiation",
      other: "Other",
      unknown: "Unknown"
    }[this.cause];
  }

  get deathLocationVerbose() {
    return {
      unknown: "unknown",
      scene: "scene",
      "sinai-hospital": "Sinai Hospital",
      "harbor-hospital": "Harbor Hospital",
      "johns-hopkins-hospital": "Johns Hopkins Hospital",
      "union-memorial-hospital": "Union Memorial Hospital",
      "johns-hopkins-bayview": "Johns Hopkins Bayview",
      "georgetown-medical-center": "Georgetown Medical Center",
      "good-samaritan-hospital": "Good Samaritan Hospital",
      "st-agnes-hospital ": "St. Agnes Hospital",
      "bon-secours-hospital": "Bon Secours Hospital",
      "shock-trauma": "Maryland Shock Trauma Center",
      ummc: "University of Maryland Medical Center"
    }[this.deathLocation];
  }

  get dateObject() {
    return DateTime.fromISO(this.dateFound);
  }

  get dateFoundVerbose() {
    return this.dateObject.toLocaleString(DateTime.DATE_MED);
  }

  get year() {
    return this.dateFound.slice(0, 4);
  }

  get yearNumber() {
    return parseInt(this.year, 10);
  }

  get monthNumber() {
    return parseInt(this.dateFound.slice(5, 7), 10);
  }
}

export default Victim;
